/**
 * Remaining time bucket labels — use `approvals.remainingTime.*` at runtime.
 * @deprecated Use ngx-translate keys under `approvals.remainingTime`.
 */
export const REMAINING_TIME_LABEL_MAP: Record<string, string> = {
  LT_8H: 'کمتر از ۸ ساعت',
  '8_16H': '۸ الی ۱۶ ساعت',
  '16_24H': '۱۶ الی ۲۴ ساعت',
};

/**
 * Default page size for approval list
 */
export const DEFAULT_PAGE_SIZE = 10;

/**
 * Page size options for approval list
 */
export const PAGE_SIZE_OPTIONS = [10, 20, 50];
